import {
  useEmotionCache
} from "./chunk-43TM32P5.mjs";

// src/emotion-cache-provider.tsx
import { CacheProvider as EmotionCacheProvider } from "@emotion/react";
import { jsx } from "react/jsx-runtime";
function CacheProvider({
  children,
  ...cacheOptions
}) {
  return /* @__PURE__ */ jsx(EmotionCacheProvider, { value: useEmotionCache(cacheOptions), children });
}

export {
  CacheProvider
};
